import React, { useEffect, useLayoutEffect } from "react";
import Home from "../LegacyCode/Home";
import MetaDecorator from "../../util/MetaDecorator";

const Agripage = () => {
  useLayoutEffect(() => {
    // Scroll to top when component mounts - useLayoutEffect runs before paint
    // The scrollable container is the .main-content Box in App.js
    const scrollContainer = document.querySelector('.main-content');
    if (scrollContainer) {
      scrollContainer.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);
  
  useEffect(() => {
    // Also scroll after a brief delay to ensure it works
    const timer = setTimeout(() => {
      const scrollContainer = document.querySelector('.main-content');
      if (scrollContainer) {
        scrollContainer.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div style={{ backgroundColor: "black", color: "white" }}>
      <MetaDecorator
        title="Autogenbots | Agri-Robots"
        description="Autogenbots provide service Agri-Robots to orchid farms, wineyards and many other farm areas. Our product can be used for spraying, weed removal, berry counting, load carrying, etc."
      />
      <Home />
    </div>
  );
};

export default Agripage;
